import { useRef, useState } from "react";
import { TopMenuItem } from "~/models/menu";
import { MegaSubMenu } from "./MegaSubMenu";
import { DropDown } from "../../../common/DropDown";
import { useDelayedClose } from "~/hooks/useDelayedClose";
import classNames from "classnames";

export const MegaMenu = (props: { id: number; items: TopMenuItem[] }) => {
  const [activeMenu, setActiveMenu] = useState<TopMenuItem | null>(null);
  const menuBarRef = useRef<HTMLDivElement>(null);
  const { resetClose, scheduleClose, cancelClose } = useDelayedClose(120);

  const openMenu = (item: TopMenuItem) => {
    resetClose();
    setActiveMenu(item);
  };

  const closeMenu = () => {
    scheduleClose(() => setActiveMenu(null));
  };

  const activeItem = activeMenu ?? null;

  return (
    <div className="tw:relative tw:w-full">
      {/* ── Trigger buttons (rendered inline in your nav) ─────────────── */}
      <div
        ref={menuBarRef}
        className="tw:flex tw:items-center tw:gap-1"
        onMouseLeave={closeMenu}
      >
        {props.items.map((item) => {
          const isActive = activeMenu === item;
          return (
            <a href={item.url} key={item.title}>
              <div
                onMouseEnter={() => openMenu(item)}
                onFocus={() => openMenu(item)}
                className={classNames(
                  "tw:px-2 tw:py-2 tw:rounded tw:text-md tw:font-semibold tw:transition-colors tw:duration-100 tw:outline-none tw:text-nowrap tw:cursor-pointer",
                  isActive
                    ? "tw:text-blue-600 tw:underline tw:underline-offset-10"
                    : "tw:text-[#011936] hover:tw:bg-blue-50 hover:tw:text-blue-700",
                )}
              >
                {item.title}
              </div>
            </a>
          );
        })}
      </div>

      {activeItem && (
        <DropDown
          refParent={menuBarRef}
          gapTop={15}
          zIndex={999}
          onMouseEnter={cancelClose}
          onMouseLeave={closeMenu}
        >
          <MegaSubMenu item={activeItem} />
        </DropDown>
      )}
    </div>
  );
};
